<template>
    <div class="home net-status-home">
        <Layout layoutType="HARDLIST" isRevenue="true" :pageTitle="$t('menu.chooseBusiness')">
            <BasiceLayout :title="$t('menu.ResourceDetails')">
                <el-table :data="gapList" border style="width: 100%;" >
                    <el-table-column prop="province" label="省份" align="center">
                    </el-table-column>
                    <el-table-column prop="operator" label="运营商" align="center">
                    </el-table-column>
                    <el-table-column prop="gapBw" label="招募带宽（M）" align="center">
                    </el-table-column>
                </el-table>
            </BasiceLayout>
        </Layout>
    </div>
</template>

<script>
    import moment from "moment";
    import { Message } from "element-ui";
    import { mapActions } from "vuex";
    import BasiceLayout from "@/components/Common/BasicLayout.vue";
    import Layout from "@/components/DatePanel/Layout.vue";

    export default {
        name: "home",
        components: {
            BasiceLayout,
            Layout
        },
        data() {
            return {
                gapList: [],
            }
        },
        methods: {
            ...mapActions([
                "getGaps"
            ]),
            async getGapsList() {
                try {
                    const res = await this.getGaps();
                    this.gapList = res.data;
                } catch (error) {
                    return Message.error('获取缺口数据失败');
                }
            },
        },
        created() {
            this.getGapsList();
        }
    };
</script>